module.exports = __webpack_public_path__ + "img/smiley_mixed_ico.6e0243de.png";